import { useMarketStatus } from '@/hooks/queries/useMarketStatus';

export function MarketStatusIndicator() {
  const { data, isLoading } = useMarketStatus();

  if (isLoading || !data) return null;

  const isOpen = data.isOpen;
  const isTradingDay = data.isTradingDay;

  // Determine display text
  let label: string;
  if (isOpen) {
    label = data.isEarlyClose ? `Open (closes ${data.closeTime})` : 'Open';
  } else if (!isTradingDay) {
    label = 'Closed';
  } else {
    // Trading day but outside hours
    label = data.reason === 'Before market open' ? 'Pre-market' : 'After hours';
  }

  return (
    <div className="flex items-center gap-1.5 text-xs" title={data.reason}>
      <span
        className={`h-2 w-2 rounded-full ${
          isOpen ? 'bg-green-500' : 'bg-gray-400'
        }`}
      />
      <span className={isOpen ? 'text-green-700' : 'text-gray-500'}>
        {label}
      </span>
    </div>
  );
}
